var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-container"},[_c('img',{staticClass:"icon",attrs:{"src":`${_vm.assetPath}${_vm.iconName}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }